// TODO: move this method to api/
import { api } from '@/api'

export const hsnQueryMixin = {
  methods: {
    async hsnQuery () {
      this.searchResult = []
      this.loading = true
      this.fetched = false
      this.searchResult = await api.apiHsnQuery(this.searchQuery, this.count, this.page, this.isKeywordPage)
      this.loading = false
      this.fetched = true
    }
  }
}
